import { api } from '~/shared/services/api';

import { ISendUserPasswordRecoveryCodeRequest } from '../interfaces/ISendUserPasswordRecoveryCodeRequest';
import { IResetUserPasswordRequest } from '../interfaces/IResetUserPasswordRequest';

export async function validateUserRecoveryCode(
  passwordRecoveryCode: string
): Promise<boolean> {
  const response = await api.post<boolean>(
    `/admin-users/validate-password-recovery-code`,
    { passwordRecoveryCode }
  );

  return response.data;
}

export async function sendUserPasswordRecoveryCode(
  data: ISendUserPasswordRecoveryCodeRequest
): Promise<void> {
  await api.post(`/admin-users/send-password-recovery-code`, data);
}

export async function resetUserPassword(
  data: IResetUserPasswordRequest
): Promise<void> {
  await api.post(`/admin-users/reset-password`, data);
}
